import { FC, Fragment } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { SkeletonLine } from './Skeleton.styles';
import { ISkeletonProps } from './Skeleton.types';

export const Skeleton: FC<ISkeletonProps> = ({
  count = 1,
  circle,
  width,
  height,
  'data-testid': testId = 'skeleton-line',
  Wrapper,
  id,
  ...otherProps
}: ISkeletonProps) => {
  const nodes = Array.from(new Array(count), (_, idx) => {
    const realIDBase = id || uuidv4();
    const body = (
      <SkeletonLine
        key={`${realIDBase}${idx}`}
        data-testid={testId}
        width={width}
        height={height}
        circle={circle}
        {...otherProps}
      />
    );

    if (Wrapper) {
      return <Wrapper key={realIDBase}>{body}</Wrapper>;
    }

    return <Fragment key={realIDBase}>{body}</Fragment>;
  });

  return <>{nodes}</>;
};

Skeleton.displayName = 'Skeleton';

export default Skeleton;
